var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-message"},[_c('div',{staticClass:"social-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.staticInfo.contacts,"stripe":"","header-cell-style":{
        background: '#17295D',
        color: '#538FBD',
      }}},[_c('el-table-column',{attrs:{"prop":"name","label":"姓名","width":"100"}}),_c('el-table-column',{attrs:{"prop":"relationshipMark","label":"关系"}}),_c('el-table-column',{attrs:{"prop":"phone","label":"联系电话","width":"120"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }